<mat-card *ngIf="selectedClient">


    <mat-card-content style="overflow: auto;height: 100%;">

        <div style="background: url('../../assets/img/morceau/titre.png');height: 60px;
         background-size: 100% 100%; width: 100%;color: #2F4395; font-size: 18px;">

            <div style="float: left;margin-top:5px;">
                <img src="../../assets/img/morceau/5.png" height="40">
               Résumé du prospect
            </div>
            <div style="float: right; cursor: pointer;" (click)="clickedMe()">
                <img src="../../assets/img/morceau/edit.png">
            </div>

        </div>

        <div style=" height: calc(100% - 60px);">
 
            {{selectedClient.observation}}




        </div>


    </mat-card-content>


</mat-card>